// Shared motion gates for pointer-driven effects (parallax, dock magnification).
// Pointer effects only run on desktop-class devices and never when the user asked for reduced motion.
export const POINTER_FX_QUERY = '(hover: hover) and (pointer: fine) and (min-width: 1024px)';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// Tablets with a mouse/trackpad (pointer effects at reduced intensity)
export const POINTER_FX_TABLET_QUERY = '(hover: hover) and (pointer: fine) and (min-width: 768px)';

export const canUsePointerFx = (query = POINTER_FX_QUERY) =>
    typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(query).matches
    && !window.matchMedia(REDUCED_MOTION_QUERY).matches;
